module.exports = __webpack_public_path__ + "static/media/UniversityofNewCastle.4e1b53d6.png";